import type { GetProductListRequest } from "../types/products";
import { ProductStatus } from "../enums/products";

export type FilterFormState = {
  name: string;
  brandName: string;
  categoryPath: string;
  status: ProductStatus | "";
  minSalesPrice: string;
  maxSalesPrice: string;
  minQuantityInStock: string;
  maxQuantityInStock: string;
  expirationDate: string;
  expirationDateFrom: string;
  expirationDateTo: string;
};

export const initialProductListFilters: FilterFormState = {
  name: "",
  brandName: "",
  categoryPath: "",
  status: "",
  minSalesPrice: "",
  maxSalesPrice: "",
  minQuantityInStock: "",
  maxQuantityInStock: "",
  expirationDate: "",
  expirationDateFrom: "",
  expirationDateTo: ""
};

/** Pagination options when building the request. */
export interface ProductListPagination {
  page?: number;
  size?: number;
}

const DEFAULT_PAGE = 0;
const DEFAULT_SIZE = 20;

/**
 * Builds API request from filter form state (only non-empty values).
 * @param f - Filter form state
 * @param pagination - Optional pagination (page, size). Defaults to page=0, size=20.
 */
export function buildProductListRequest(
  f: FilterFormState,
  pagination?: ProductListPagination
): GetProductListRequest {
  const out: GetProductListRequest = {
    page: pagination?.page ?? DEFAULT_PAGE,
    size: pagination?.size ?? DEFAULT_SIZE
  };
  if (f.name.trim()) out.name = f.name.trim();
  if (f.brandName.trim()) out.brandName = f.brandName.trim();
  if (f.categoryPath.trim()) out.categoryPath = f.categoryPath.trim();
  if (f.status) out.status = f.status as ProductStatus;
  const minP = parseFloat(f.minSalesPrice);
  if (!Number.isNaN(minP)) out.minSalesPrice = minP;
  const maxP = parseFloat(f.maxSalesPrice);
  if (!Number.isNaN(maxP)) out.maxSalesPrice = maxP;
  const minQ = parseFloat(f.minQuantityInStock);
  if (!Number.isNaN(minQ)) out.minQuantityInStock = minQ;
  const maxQ = parseFloat(f.maxQuantityInStock);
  if (!Number.isNaN(maxQ)) out.maxQuantityInStock = maxQ;
  if (f.expirationDate.trim()) out.expirationDate = f.expirationDate.trim();
  if (f.expirationDateFrom.trim())
    out.expirationDateFrom = f.expirationDateFrom.trim();
  if (f.expirationDateTo.trim())
    out.expirationDateTo = f.expirationDateTo.trim();
  return out;
}

export { DEFAULT_PAGE, DEFAULT_SIZE };
